import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  dashboard_counts,
  dashboard_api,
  bulk_gift_configs,
  user_bulk_upload_direct_approve as userBulkUploadDirectApproveApi,
  declaration_configs,
  submit_declaration as submitDeclarationApi,
  bu_master as buMasterApi,
  get_declared_gifts_count as getDeclaredGiftsCountApi
} from './api';

const initialState = {
  getDashboardCountsLoading: false,
  getWaitingForOthersLoading: false,
  getActionRequiredLoading: false,
  getApprovedLoading: false,
  getRejectedLoading: false,
  acceptedCount: '',
  pendingCount: '',
  rejectedCount: '',
  returnedCount: '',
  waitingForOthersCount: '',
  waitingForOthersList: [],
  actionRequiredList: [],
  approvedList: [],
  rejectedList: [],
  giftType: '',
  get_bulk_gift_configsLoading: false,
  bulkGiftConfigs: [],
  bulkGiftConfigsPagination: {},
  user_bulk_upload_direct_approveLoading: false,
  get_declaration_configsLoading: false,
  declarationConfigs: [],
  declarationConfigsPagination: {},
  submit_declarationLoading: false,
  get_bu_masterLoading: false,
  buMasterList: [],
  get_declared_gifts_countLoading: false,
  declaredGiftsCount: 0
};

const actions = {
  GET_DASHBOARD_COUNTS: 'getDashboardCounts/GET_DASHBOARD_COUNTS',
  GET_WAITING_FOR_OTHERS: 'getWaitingForOthers/GET_WAITING_FOR_OTHERS',
  GET_ACTION_REQUIRED: 'getActionRequired/GET_ACTION_REQUIRED',
  GET_APPROVED: 'getApproved/GET_APPROVED',
  GET_REJECT: 'getRejected/GET_REJECT',
  GET_BULK_GIFT_CONFIGS: 'getBulkGiftConfigs/GET_BULK_GIFT_CONFIGS',
  USER_BULK_UPLOAD_DIRECT_APPROVE:
    'userBulkUploadDirectApprove/USER_BULK_UPLOAD_DIRECT_APPROVE',
  GET_DECLARATION_CONFIGS: 'getDeclarationConfigs/GET_DECLARATION_CONFIGS',
  SUBMIT_DECLARATION: 'submitDeclaration/SUBMIT_DECLARATION',
  GET_BU_MASTER: 'get_bu_maste/GET_BU_MASTER',
  GET_DECLARED_GIFTS_COUNT: 'get_declared_gifts_count/GET_DECLARED_GIFTS_COUNT'
};
export const getDashboardCounts = createAsyncThunk(
  actions.GET_DASHBOARD_COUNTS,
  async (payload) => {
    const response = await dashboard_counts(payload);
    console.log('response', response);
    return response;
  }
);
export const getWaitingForOthers = createAsyncThunk(
  actions.GET_WAITING_FOR_OTHERS,
  async (payload) => {
    const response = await dashboard_api(`qa-waiting-for-others`, payload);
    return response;
  }
);
export const getActionRequired = createAsyncThunk(
  actions.GET_ACTION_REQUIRED,
  async (payload) => {
    const response = await dashboard_api(`qa-action-required`, payload);
    return response;
  }
);
export const getApproved = createAsyncThunk(
  actions.GET_APPROVED,
  async (payload) => {
    const response = await dashboard_api(`qa-approved`, payload);
    return response;
  }
);
export const getRejected = createAsyncThunk(
  actions.GET_REJECT,
  async (payload) => {
    const response = await dashboard_api(`qa-rejected`, payload);
    return response;
  }
);
export const get_bulk_gift_configs = createAsyncThunk(
  actions.GET_BULK_GIFT_CONFIGS,
  async (payload) => {
    const response = await bulk_gift_configs(payload);
    return response;
  }
);

export const user_bulk_upload_direct_approve = createAsyncThunk(
  actions.USER_BULK_UPLOAD_DIRECT_APPROVE,
  async (payload) => {
    const response = await userBulkUploadDirectApproveApi(payload);
    return response;
  }
);

export const get_declaration_configs = createAsyncThunk(
  actions.GET_DECLARATION_CONFIGS,
  async (payload) => {
    const response = await declaration_configs(payload);
    return response;
  }
);

export const submit_declaration = createAsyncThunk(
  actions.SUBMIT_DECLARATION,
  async (payload) => {
    const response = await submitDeclarationApi(payload);
    return response;
  }
);

export const get_bu_master = createAsyncThunk(
  actions.GET_BU_MASTER,
  async (payload = { page: 1, per_page: 20 }) => {
    const response = await buMasterApi(payload);
    return response;
  }
);

export const get_declared_gifts_count = createAsyncThunk(
  actions.GET_DECLARED_GIFTS_COUNT,
  async (payload) => {
    const response = await getDeclaredGiftsCountApi(payload);
    return response;
  }
);
// export const getReturn = createAsyncThunk(
//   actions.GET_RETURN,
//   async (payload) => {
//     const response = await dashboard_api(`qa-rejected`, payload);
//     return response;
//   }
// );
export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    giftTypes: (state, action) => {
      state.giftType = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardCounts.pending, (state) => {
        state.getDashboardCountsLoading = true;
      })
      .addCase(getDashboardCounts.fulfilled, (state, action) => {
        console.log('action.payload', action.payload);
        const {
          acceptedCount,
          pendingCount,
          rejectedCount,
          returnedCount,
          waitingForOthersCount,
          pagination
        } = action.payload;

        state.getDashboardCountsLoading = false;
        state.acceptedCount = acceptedCount ? acceptedCount : '';
        state.pendingCount = pendingCount ? pendingCount : '';
        state.rejectedCount = rejectedCount ? rejectedCount : '';
        state.returnedCount = returnedCount ? returnedCount : '';
        state.waitingForOthersCount = waitingForOthersCount
          ? waitingForOthersCount
          : '';
        state.pagination = pagination || null;
      })
      .addCase(getDashboardCounts.rejected, (state) => {
        state.getDashboardCountsLoading = false;
      });
    builder
      .addCase(getWaitingForOthers.pending, (state) => {
        state.getWaitingForOthersLoading = true;
      })
      .addCase(getWaitingForOthers.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.getWaitingForOthersLoading = false;
        state.waitingForOthersList = data ? data : [];
        state.pagination = pagination || null;
      })
      .addCase(getWaitingForOthers.rejected, (state) => {
        state.getWaitingForOthersListLoading = false;
      });
    ///
    builder
      .addCase(getActionRequired.pending, (state) => {
        state.getActionRequiredLoading = true;
      })
      .addCase(getActionRequired.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.getActionRequiredLoading = false;
        state.actionRequiredList = data ? data : [];
        state.pagination = pagination || null;
      })
      .addCase(getActionRequired.rejected, (state) => {
        state.getActionRequiredLoading = false;
      });
    ///
    builder
      .addCase(getApproved.pending, (state) => {
        state.getApprovedLoading = true;
      })
      .addCase(getApproved.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.getApprovedLoading = false;
        state.approvedList = data ? data : [];
        state.pagination = pagination || null;
      })
      .addCase(getApproved.rejected, (state) => {
        state.getApprovedLoading = false;
      });
    ////
    builder
      .addCase(getRejected.pending, (state) => {
        state.getRejectedLoading = true;
      })
      .addCase(getRejected.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.getRejectedLoading = false;
        state.rejectedList = data ? data : [];
        state.pagination = pagination || null;
      })
      .addCase(getRejected.rejected, (state) => {
        state.getRejectedLoading = false;
      });
    builder
      .addCase(get_bulk_gift_configs.pending, (state) => {
        state.get_bulk_gift_configsLoading = true;
      })
      .addCase(get_bulk_gift_configs.fulfilled, (state, action) => {
        const { success, data, message: msg, pagination } = action.payload;
        state.get_bulk_gift_configsLoading = false;
        state.bulkGiftConfigs = data ? data : [];
        state.bulkGiftConfigsPagination = pagination || {};

        if (!success) {
          message.error(msg);
        }
      })
      .addCase(get_bulk_gift_configs.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.get_bulk_gift_configsLoading = false;

        message.error(msg);
      })
      .addCase(user_bulk_upload_direct_approve.pending, (state) => {
        state.user_bulk_upload_direct_approveLoading = true;
      })
      .addCase(user_bulk_upload_direct_approve.fulfilled, (state) => {
        state.user_bulk_upload_direct_approveLoading = false;
      })
      .addCase(user_bulk_upload_direct_approve.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.user_bulk_upload_direct_approveLoading = false;
        message.error(msg);
      });
    builder
      .addCase(get_declaration_configs.pending, (state) => {
        state.get_declaration_configsLoading = true;
      })
      .addCase(get_declaration_configs.fulfilled, (state, action) => {
        const { success, data, message: msg, pagination } = action.payload;
        state.get_declaration_configsLoading = false;
        state.declarationConfigs = data ? data : [];
        state.declarationConfigsPagination = pagination || {};

        if (!success) {
          message.error(msg);
        }
      })
      .addCase(get_declaration_configs.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.get_declaration_configsLoading = false;
        message.error(msg);
      });
    builder
      .addCase(submit_declaration.pending, (state) => {
        state.submit_declarationLoading = true;
      })
      .addCase(submit_declaration.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.submit_declarationLoading = false;
        if (success) {
          message.success(msg || 'Declaration submitted successfully');
        } else {
          message.error(msg || 'Failed to submit declaration');
        }
      })
      .addCase(submit_declaration.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.submit_declarationLoading = false;
        message.error(msg || 'Failed to submit declaration');
      });
    builder
      .addCase(get_bu_master.pending, (state) => {
        state.get_bu_masterLoading = true;
      })
      .addCase(get_bu_master.fulfilled, (state, action) => {
        const { success, data, message: msg } = action.payload || {};
        state.get_bu_masterLoading = false;
        state.buMasterList = Array.isArray(data) ? data : [];
        if (success === false && msg) {
          message.error(msg);
        }
      })
      .addCase(get_bu_master.rejected, (state, action) => {
        state.get_bu_masterLoading = false;
        if (action.error?.message) message.error(action.error.message);
      });
    builder
      .addCase(get_declared_gifts_count.pending, (state) => {
        state.get_declared_gifts_countLoading = true;
      })
      .addCase(get_declared_gifts_count.fulfilled, (state, action) => {
        const { data } = action.payload || {};
        state.get_declared_gifts_countLoading = false;
        state.declaredGiftsCount = data || 0;
      })
      .addCase(get_declared_gifts_count.rejected, (state) => {
        state.get_declared_gifts_countLoading = false;
      });
  }
});
export const { giftTypes } = dashboardSlice.actions;
export default dashboardSlice.reducer;
